<template>
	<ContainerDefault>
		<div class="flex flex-col min-h-screen">

			<!-- Main Content (Split into Left and Right Sides) -->
			<div class="flex-grow flex md:pb-12 xxxl:pb-4 relative">

				<!-- Left Side -->
				<div ref="leftContent" class="hidden lg:flex lg:w-1/2 justify-end md:pr-[43px] left-side">
					<div class="max-w-[558px] text-left">
						<img src="@/assets/images/logo/m4c-logo-dark.svg" alt="Media4Change" class="w-[166px] h-[66px] mt-[2px] ml-[1px] mb-6 mx-auto" />
						<h2 class="text-4xl leading-12 font-bold mt-5 mb-0 ml-[1px] pt-[1px]" v-html="addLineBreaks(t('intro.title'))"></h2>
						<p class="text-xl leading-8 mt-4 pr-3">
							{{ t('intro.text') }}
						</p>
						<div class="mt-[34px] pl-[5px] flex justify-center">
							<img src="@/assets/images/elements/chat-dark-v2.svg" alt="Media4Change" class="max-w-[452px]" />
						</div>
					</div>
				</div>

				<!-- Right Side -->
				<div class="flex w-full lg:w-1/2 items-center justify-center lg:justify-start pt-6 pl-4 pr-4 pb-4 lg:pt-8 lg:pl-[114px]">
					<div class="max-w-[486px] w-full">
						<slot></slot>
					</div>
				</div>

			</div>

			<!-- Footer Component -->
			<AppFooter />
		</div>
	</ContainerDefault>
</template>



<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const { t } = useI18n();
const isShortScreen = ref(false);

const classes = ['bg-het-stream', 'bg-azureish-white', 'bg-sky-blue', 'bg-crystal-blue'];

const leftContent = ref<HTMLElement | null>(null);

// Function to center the left side vertically
function centerLeftContent() {
	if (leftContent.value) {
		const parentHeight = leftContent.value.parentElement?.clientHeight || 0;
		const contentHeight = leftContent.value.clientHeight;
		const topOffset = (parentHeight - contentHeight) / 2;
		leftContent.value.style.transform = `translateY(${topOffset}px)`;
	}
}

// Function to add <br> after every 4 words
function addLineBreaks(text: string, wordsPerLine: number = 4): string {
	const words = text.split(' '); // Split the text by spaces
	let result = '';

	// Loop through the words and add <br> after every 'wordsPerLine' words
	for (let i = 0; i < words.length; i++) {
		result += words[i] + ' ';
		if ((i + 1) % wordsPerLine === 0 && i !== words.length - 1) {
			result += '<br>';
		}
	}

	return result.trim();
}

// Function to check screen height and update the state
function updateScreenHeight() {
	isShortScreen.value = window.innerHeight < 800;
}

function setRandomBodyClass() {
	let selectedClass = sessionStorage.getItem('randomBodyClass');
	if (!selectedClass) {
		selectedClass = classes[Math.floor(Math.random() * classes.length)];
		sessionStorage.setItem('randomBodyClass', selectedClass);
	}
	document.body.classList.add(selectedClass);
}

onMounted(() => {
	centerLeftContent();
	window.addEventListener('resize', centerLeftContent);
	setRandomBodyClass();
});

onBeforeUnmount(() => {
	window.removeEventListener('resize', centerLeftContent);
});
</script>

<style scoped>
.flex-grow {
	flex-grow: 1;
}

/* Left side container */
.left-side {
	position: relative;
	height: 100%;
}

/* Centering transform for left content */
.left-side > div {
	position: relative;
	transform: translateY(0);
}
</style>

